// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__OqThE","inner":"Footer_inner__1bUTi"};